import React from "react";

/**
 * QuestionCard — a single question wrapper used on the /today form.
 * Consistent card styling + question numbering.
 */
export function QuestionCard({ number, title, children, testId }) {
  return (
    <section
      className="dc-card p-5"
      data-testid={testId}
      aria-labelledby={`${testId}-title`}
    >
      <div className="flex items-baseline gap-2 mb-4">
        <span
          className="text-[11px] font-medium text-[#F4C95D]/80 tracking-[0.14em]"
          style={{ letterSpacing: "0.14em" }}
        >
          {String(number).padStart(2, "0")}
        </span>
        <h3
          id={`${testId}-title`}
          className="text-[15px] sm:text-base font-medium text-[#F8FAFC] leading-snug"
          style={{ letterSpacing: "-0.01em" }}
        >
          {title}
        </h3>
      </div>
      {children}
    </section>
  );
}
